module.exports = __webpack_public_path__ + "img/Abydos.5ff4b220.png";